"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const PageContent_1 = __importDefault(require("../PageContent"));
const styles_1 = require("./styles");
const Api_1 = require("../../lib/Api");
const lib_1 = require("use-debounce/lib");
const ApiHook_1 = require("../../lib/ApiHook");
const SecurePage_1 = require("../SecurePage");
const ColumnSettings_1 = require("./ColumnSettings");
const LogsPage = ({ correlationId }) => {
    var _a, _b, _c;
    const [api, setApiParams] = ApiHook_1.useApiHook(Api_1.getLogs, {
        filterByLevel: 'ALL',
        filterByCorrelationId: correlationId
    });
    // When contextModalContent is not null a Panel
    // will be opened to display the content
    const [contextModalContent, setContextModalContent] = react_1.default.useState(null);
    const [columns] = react_1.default.useState(ColumnSettings_1.getInitialColumns(ctx => setContextModalContent(ctx)));
    const [updateParams] = lib_1.useDebouncedCallback((newParams) => setApiParams(newParams), 350 // delay in ms
    );
    return (react_1.default.createElement(SecurePage_1.SecurePage, null,
        react_1.default.createElement(PageContent_1.default, { title: "Logs" },
            react_1.default.createElement("div", { style: styles_1.styles.controlWrapper },
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Filter by Level:", selectedKey: (_b = (_a = api.params) === null || _a === void 0 ? void 0 : _a.filterByLevel) !== null && _b !== void 0 ? _b : 'ALL', options: [
                        { key: 'ALL', text: 'Show All' },
                        { key: 'INFO', text: 'INFO' },
                        { key: 'DEBUG', text: 'DEBUG' },
                        { key: 'WARN', text: 'WARN' },
                        { key: 'ERROR', text: 'ERROR' },
                        { key: 'CRITICAL', text: 'CRITICAL' },
                    ], styles: styles_1.styles.dropdown, onChange: (_, option) => updateParams({ ...api.params, filterByLevel: option === null || option === void 0 ? void 0 : option.key.toString() }) }),
                react_1.default.createElement(office_ui_fabric_react_1.TextField, { label: "Filter by Code:", styles: styles_1.styles.textField, onChange: (_, value) => updateParams({ ...api.params, filterByCode: value }) }),
                react_1.default.createElement(office_ui_fabric_react_1.TextField, { label: "Filter by CorrelationId:", styles: styles_1.styles.textFieldLong, onChange: (_, value) => updateParams({ ...api.params, filterByCorrelationId: value }) })),
            api.isError
                ? react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.error, isMultiline: false, dismissButtonAriaLabel: "Close" }, "Failed to load logs. Something went wrong.")
                : react_1.default.createElement(office_ui_fabric_react_1.ShimmeredDetailsList, { items: (_c = api.data) !== null && _c !== void 0 ? _c : [], columns: columns, selectionMode: office_ui_fabric_react_1.SelectionMode.none, layoutMode: office_ui_fabric_react_1.DetailsListLayoutMode.justified, isHeaderVisible: true, enableShimmer: api.isLoading })),
        react_1.default.createElement(office_ui_fabric_react_1.Panel, { headerText: "Context", isOpen: !!contextModalContent, onDismiss: () => setContextModalContent(null), closeButtonAriaLabel: "Close", type: office_ui_fabric_react_1.PanelType.medium, isLightDismiss: true },
            react_1.default.createElement("pre", null,
                react_1.default.createElement("code", null, contextModalContent && formatJson(contextModalContent))))));
};
const formatJson = (source) => {
    let json = {};
    try {
        json = JSON.parse(source);
    }
    catch (e) {
        return source;
    }
    return JSON.stringify(json, null, 4);
};
exports.default = LogsPage;
